/**
 * StubUserService - User service for export mode
 *
 * Returns "all features enabled" since exported packages are already
 * paid for by enterprise users. No need to check tiers or features.
 */

import type {
  IUserProfileService,
  UserProfileData,
  FeatureKey,
} from '../interfaces';

export class StubUserService implements IUserProfileService {
  /**
   * In export mode, we don't have user profiles
   * Return null to indicate no user context
   */
  async getUserProfile(_userId: string): Promise<UserProfileData | null> {
    // Export mode: no user profiles available
    // The export was already authorized at download time
    return null;
  }

  /**
   * In export mode, all features are enabled
   * The user already paid for enterprise to get the export
   */
  hasFeatureAccess(_profile: UserProfileData, _feature: FeatureKey): boolean {
    // All features enabled in export mode
    // White-label, analytics, etc. are all available
    return true;
  }
}
